<template>
	<div>
		<div>武林秘籍：九阴之人气</div>
		<!-- <SentimentMarketHotTrend  zoom_start="0"></SentimentMarketHotTrend> -->
		<QuantJyJyPool quant_code="9009" title="九阴之人气" zoom_start="45"></QuantJyJyPool>
	</div>
</template>

<script>
	import QuantJyJyPool from 'components/quant/QuantJyJyPool.vue'
	// import SentimentMarketHotTrend from 'components/sentiment/SentimentMarketHotTrend.vue'
	export default {
		data() {
			return {
			}
		},
		components: {
			QuantJyJyPool,
			// SentimentMarketHotTrend
		},
		methods: {

		}
	}
</script>

<style>
</style>
